// extracted by mini-css-extract-plugin
module.exports = {"root":"IconTrash_root__3Yu1F"};